import InstitutionFuturesDecisionMakerOnboardingForm from '@/features/institution/futures/decision-maker/components/onboarding-form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingDecisionMakerPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="decisionMaker" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionFuturesDecisionMakerOnboardingForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingDecisionMakerPage.displayName = 'InstitutionOnboardingDecisionMakerPage';

export default InstitutionOnboardingDecisionMakerPage;
